import React from 'react';
import { compose, mapProps } from 'recompose';
import { graphql } from 'react-apollo';
import { withTranslation } from 'react-i18next';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { sortUsersByCurrentFirst } from 'utils/functions';
import CircularBadge from 'components/common/Badge/CircularBadge';
import UserBadge from 'components/threepp/UserBadge/UserBadge';
import { getCurrentUser } from 'graphql/operations';
import { getCurrentUser as getCurrentUserSelector } from 'selectors/user/selector';

import './Participants.scss';

const MAX_BADGES = 5;

export const Participants = props => {
  const { users = [], currentUser, maxBadges = MAX_BADGES, hideIfNoParticipants = false } = props;

  const sortedUsers = [...users];
  sortedUsers.sort(sortUsersByCurrentFirst(currentUser));

  const participantInfo = sortedUsers.map(user => <UserBadge key={user.email} noName user={user} />);

  let angleDown;
  let noParticipants = false;
  if (participantInfo.length === 0) {
    noParticipants = true;
    participantInfo.push(
      <div key="too-few" className="no-participants">
        <GroupAddIcon className="add-participant-icon" />
      </div>
    );
  } else if (participantInfo.length > maxBadges) {
    const extraParticipantCount = participantInfo.length - maxBadges + 1;

    const badgeLabel = `+${extraParticipantCount}`;

    participantInfo.splice(maxBadges - 1, extraParticipantCount, <CircularBadge key="too-many" className="more-participants" value={badgeLabel} />);
  }

  if (hideIfNoParticipants && noParticipants) {
    return '';
  }

  if (!noParticipants) {
    angleDown = <ArrowDropDownIcon className="collapse-icon-participant" icon="angle-down" />;
  }

  return (
    <div className="participants">
      <div className="participant-info">
        {participantInfo}
        {angleDown}
      </div>
    </div>
  );
};

export const ParticipantsHOC = compose(
  withTranslation(),
  graphql(getCurrentUser, { name: 'getCurrentUser' }),
  mapProps(props => ({
    t: props.t,
    maxBadges: props.maxBadges,
    users: props.users,
    hideIfNoParticipants: props.hideIfNoParticipants,
    currentUser: getCurrentUserSelector(props)
  }))
);

export default ParticipantsHOC(Participants);
